var _circle, _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "medal",
    viewBox: "0 0 640 640",
    fill: "#666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#666",
    strokeWidth: 20,
    cx: 320,
    cy: 416.3,
    r: 184.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.3,318.9l26.1,52.9c1,2.1,3,3.5,5.3,3.8l58.4,8.5c5.8,0.8,8.1,7.9,3.9,12l-42.3,41.2c-1.7,1.6-2.4,3.9-2,6.2l10,58.2c1,5.7-5,10.1-10.2,7.4l-52.3-27.5c-2-1.1-4.5-1.1-6.5,0l-52.3,27.5c-5.2,2.7-11.2-1.7-10.2-7.4l10-58.2c0.4-2.3-0.4-4.6-2-6.2l-42.3-41.2c-4.2-4.1-1.9-11.2,3.9-12l58.4-8.5c2.3-0.3,4.3-1.8,5.3-3.8l26.1-52.9C317.3,313.7,324.7,313.7,327.3,318.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leaves"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.4,559c3.3,3.9-7.9,22-12.6,19.9c-2.6-1.1-4-5.7,1-12.5C313.9,559.6,318.5,556.8,320.4,559z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.6,558.4c4.8-1.7,17.8,15.1,14.2,18.8c-2,2.1-6.7,1.7-11.3-5.4C316.8,564.6,315.8,559.3,318.6,558.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.9,312.4c0,0,13.8,7.7,19.4,21.7c5.6,14,0.9,29.1,0.9,29.1s-13.8-7.7-19.4-21.7C430.2,327.5,434.9,312.4,434.9,312.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.2,362.5c0,0,4.2,15.2-1.9,29.1c-6.1,13.8-20.2,21-20.2,21s-4.2-15.2,1.9-29.1C453.1,369.7,467.2,362.5,467.2,362.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.6,411.7c0,0,0.6,15.8-8.5,27.9s-24.4,15.9-24.4,15.9s-0.6-15.8,8.5-27.9C455.2,415.5,470.6,411.7,470.6,411.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.3,460.3c0,0-4.6,15.1-17.1,23.6s-28.3,7-28.3,7s4.6-15.1,17.1-23.6S468.3,460.3,468.3,460.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.2,499.9c0,0-8,13.6-22.1,18.9c-14.1,5.3-29.1,0.3-29.1,0.3s8-13.6,22.1-18.9S452.2,499.9,452.2,499.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.8,534.9c0,0-10.9,11.4-25.9,13.3c-15,1.9-28.4-6.5-28.4-6.5s10.9-11.4,25.9-13.3S416.8,534.9,416.8,534.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.6,561.1c0,0-13.8,7.7-28.7,5c-14.9-2.7-25.2-14.7-25.2-14.7s13.8-7.7,28.7-5C364.3,549.1,374.6,561.1,374.6,561.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.2,313.3c0,0-12.8,9.3-16.6,23.9c-3.9,14.6,2.6,29,2.6,29s12.8-9.3,16.6-23.9C205.7,327.7,199.2,313.3,199.2,313.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.1,362.5c0,0-4.2,15.2,1.9,29.1c6.1,13.8,20.2,21,20.2,21s4.2-15.2-1.9-29.1C185.1,369.7,171.1,362.5,171.1,362.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.7,411.7c0,0-0.6,15.8,8.5,27.9c9.1,12.1,24.4,15.9,24.4,15.9s0.6-15.8-8.5-27.9C183,415.5,167.7,411.7,167.7,411.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.9,460.3c0,0,4.6,15.1,17.1,23.6s28.3,7,28.3,7s-4.6-15.1-17.1-23.6S169.9,460.3,169.9,460.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.1,499.9c0,0,8,13.6,22.1,18.9c14.1,5.3,29.1,0.3,29.1,0.3s-8-13.6-22.1-18.9S186.1,499.9,186.1,499.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.5,534.9c0,0,10.9,11.4,25.9,13.3c15,1.9,28.4-6.5,28.4-6.5s-10.9-11.4-25.9-13.3S221.5,534.9,221.5,534.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.6,561.1c0,0,13.8,7.7,28.7,5c14.9-2.7,25.2-14.7,25.2-14.7s-13.8-7.7-28.7-5S263.6,561.1,263.6,561.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ribbon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 200,
    width: 28.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.1,201.3l-34.9-60.4c-2-3.4-2-7.6,0-11l54.7-94.8c2-3.4,5.6-5.5,9.5-5.5l55.6,0.2c8.4,0,13.7,9.2,9.4,16.5l-90.4,155C367.1,202.8,365,202.8,364.1,201.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,205.5h-68.8c-3.8,0-7.2-2-9.1-5.3L188.3,45c-4-7,1-15.7,9-15.8l55.5-0.4c3.8,0,7.3,2,9.2,5.3l96.4,167C359.6,203.1,358.1,205.5,355.9,205.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.f4f520f6797be32f202b610a23016e02.svg";
export { ForwardRef as ReactComponent };